import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../utils/api';
import './Pending.css';

export default function Pending() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [payment, setPayment] = useState(null);

  useEffect(() => {
    if (!user) return navigate('/login');
    if (user.status === 'approved') return navigate('/dashboard');
    API.get('/api/payment/status').then(r => setPayment(r.data.payment)).catch(() => {});
  }, [user, navigate]);

  const handleLogout = () => { logout(); navigate('/'); };

  const statusConfig = {
    pending: {
      icon: '⏳', color: '#856404', bg: '#fff3cd',
      title: 'Awaiting Admin Verification',
      titleTa: 'நிர்வாக சரிபார்ப்பு நிலுவையில் உள்ளது',
      desc: 'Your payment has been received. Our admin team will verify it within 24 hours. You will be notified once your profile is approved.',
    },
    rejected: {
      icon: '❌', color: '#721c24', bg: '#f8d7da',
      title: 'Payment Verification Failed',
      titleTa: 'பணம் செலுத்துதல் சரிபார்ப்பு தோல்வியடைந்தது',
      desc: 'Your payment could not be verified. Please re-submit your payment with the correct Transaction ID.',
    },
  };

  const payStatus = payment?.status || 'pending';
  const config = statusConfig[payStatus] || statusConfig.pending;

  return (
    <div className="pending-page">
      <div className="container pending-content">
        <div className="pending-card">
          {/* Status Banner */}
          <div className="pending-status-banner" style={{background: config.bg, borderColor: config.color}}>
            <span className="pending-icon">{config.icon}</span>
            <div>
              <h2 style={{color: config.color}}>{config.title}</h2>
              <p style={{color: config.color, opacity: 0.8}}>{config.titleTa}</p>
            </div>
          </div>

          <p className="pending-desc">{config.desc}</p>

          {/* Payment Info */}
          {payment && (
            <div className="pending-payment-info">
              <h3>Payment Details</h3>
              <div className="ppi-row"><span>Amount Paid</span><strong>₹{payment.amount}</strong></div>
              <div className="ppi-row"><span>Transaction ID</span><strong>{payment.transaction_id}</strong></div>
              <div className="ppi-row"><span>Submitted On</span><strong>{new Date(payment.payment_date).toLocaleString('en-IN')}</strong></div>
              <div className="ppi-row">
                <span>Status</span>
                <span className={`badge badge-${payment.status}`} style={{textTransform:'capitalize'}}>
                  {payment.status}
                </span>
              </div>
            </div>
          )}

          {/* Timeline */}
          <div className="pending-timeline">
            <h3>What Happens Next?</h3>
            <div className="timeline-steps">
              {[
                { icon: '✅', label: 'Registration Complete', done: true },
                { icon: '💳', label: 'Payment Submitted', done: !!payment },
                { icon: '🔍', label: 'Admin Verifying (within 24 hrs)', done: false },
                { icon: '🎉', label: 'Profile Approved — Browse Profiles!', done: false },
              ].map((s, i) => (
                <div key={i} className={`tl-step ${s.done ? 'done' : ''}`}>
                  <div className="tl-icon">{s.icon}</div>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className="pending-actions">
            {payStatus === 'rejected' ? (
              <Link to="/payment" className="btn btn-gold btn-lg">
                💳 Re-Submit Payment
              </Link>
            ) : (
              <>
                {!payment && (
                  <Link to="/payment" className="btn btn-gold">
                    💳 Complete Payment
                  </Link>
                )}
                <div className="pending-contact">
                  <p>Need help? Contact us:</p>
                  <a href="tel:+91 9842724724" className="btn btn-outline">📞 +91 9842724724</a>
                </div>
              </>
            )}
            <button className="btn btn-outline" onClick={handleLogout}>Logout</button>
          </div>
        </div>
      </div>
    </div>
  );
}
